import {
  GET_GROUP_BUYING_REPORT_LIST_DONE,
  GET_MEMBER_REPORT_LIST_DONE,
  GETTING_GROUP_BUYING_REPORT_LIST,
  GETTING_MEMBER_REPORT_LIST,
  SET_MEMBER_REPORT_RANGE,
  SET_SEARCH_DATE_TYPE,
} from './constants';

export default {
  [GET_GROUP_BUYING_REPORT_LIST_DONE](state, list) {
    state.groupBuyingReportList = list;
  },
  [GET_MEMBER_REPORT_LIST_DONE](state, list) {
    state.memberReportList = list;
  },
  [GETTING_GROUP_BUYING_REPORT_LIST](state, getting) {
    state.gettingGroupBuyingReportList = getting;
  },
  [GETTING_MEMBER_REPORT_LIST](state, getting) {
    state.gettingMemberReportList = getting;
  },
  [SET_MEMBER_REPORT_RANGE](state, range) {
    state.memberReportRange = range;
  },
  [SET_SEARCH_DATE_TYPE](state, type = 'start') {
    state.searchDateType = type;
  },
};
